import type { Method } from '@luna/api';

import { getImageVariantBySize } from './ImageVariantsService';
import { getGeorgeByteImage } from './getGeorgeByteImage';

export function isImageData(imageUrl: string): boolean {
    return imageUrl.startsWith('data:');
}

export function isAssetsImage(imageUrl: string): boolean {
    return imageUrl.startsWith('/assets/');
}

const IMAGE_VARIANT_SIZE = 128;

export function getImageData(
    imageUrl: string,
    sendAcceptHeader: boolean,
    method: Method,
    sendImageVariant: boolean,
): Promise<string> {
    return new Promise((resolve) => {
        getGeorgeByteImage(imageUrl, resolve, {
            sendAcceptHeader,
            method,
            useCache: true,
            variant: getImageVariantBySize(IMAGE_VARIANT_SIZE),
            sendImageVariantParam: sendImageVariant,
        });
    });
}
